  export enum AssetType {
    Vehicles = 'vehicles',
    Motorcycles = 'motorcycles',
    Caravans = 'caravans',
    Buildings = 'buildings',
    Contents = 'contents',
    AllRisks = 'all_risks',
    SpecifiedItems = 'specified_items',
    Other = 'other',
    UserPersonalDetails = 'users_personal_details',
    UserInsuranceHistory = 'users_insurance_history',
    Vaps = 'vaps',
    PersonalLiability = 'personal_liability'
  }